import { Grid, styled } from '@mui/material'
import React, { ReactNode } from 'react'

const FilterBar = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),

  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(2)
  }
}))

interface BasicPageFilterBarProps {
  children: ReactNode
  clearResults?: ReactNode
}

function BasicPageFilterBar({ children, clearResults }: BasicPageFilterBarProps) {
  return (
    <Grid container pb={2}>
      <FilterBar item xs={12}>
        {children}
      </FilterBar>
      {clearResults}
    </Grid>
  )
}

export default BasicPageFilterBar
